











































































































































































































import { BulletinDeSalaireApi } from "../api/BulletinDeSalaireApi";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import ExportButton from "../core/UI/ExportButton.vue";
import Pagination from "../core/UI/Pagination.vue";
import PerPage from "../core/UI/PerPage.vue";
import BulletinDeSalaireListFilters from "./BulletinDeSalaireListPartials/BulletinDeSalaireListFilters.vue";
import AutoRefresh from "../core/Table/AutoRefresh.vue";
import BulletinDeSalaireModal from "./BulletinDeSalaireModal.vue";
import BulletinDeSalaireImportModal from "./BulletinDeSalaireImportModal.vue";

export default {
    name: "BulletinDeSalaireList",
    components: {
        ExportButton,
        Pagination,
        PerPage,
        BulletinDeSalaireListFilters,
        AutoRefresh,
        BulletinDeSalaireModal,
        BulletinDeSalaireImportModal,
    },
    data() {
        return {
            bulletins: [],
            totalBrut: 0,
            totalNet: 0,
            totalEmployeur: 0,
            BulletinDeSalaireApi: new BulletinDeSalaireApi(),
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            loading: false,
            filters: {},
            sort: "",
            bulletinDeSalaireModal: {
                bulletinDeSalaireId: null,
                isNew: false,
                forceEditing: false,
            },
            showImportModal: false,
        };
    },
    created() {
        this.loadPage(this.currentPage);
    },
    methods: {
        loadPage(page, hideLoading = false) {
            let self = this;
            let params = {
                limit: self.itemsPerPage,
                page: page,
                include: "files,employe",
                sort: this.sort,
            };

            params = _.assign(params, self.filters);
            self.loading = !hideLoading;

            return self.BulletinDeSalaireApi.getAll(params)
                .then(function (response) {
                    let { data, metadata, paginator } = response;
                    self.bulletins = data;
                    self.totalPages = paginator.total_pages;
                    self.currentPage = paginator.current_page;
                    self.totalBrut = metadata ? metadata.total_brut : 0;
                    self.totalNet = metadata ? metadata.total_net : 0;
                    self.totalEmployeur = metadata
                        ? metadata.total_employeur
                        : 0;

                    return self.bulletins;
                })
                .catch(function (error) {
                    self.bulletins = [];
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        getBulletins() {
            return this.loadPage(this.currentPage);
        },
        refreshBulletins() {
            if (!this.loading) {
                this.loadPage(this.currentPage, true);
            }
        },
        updateFilters(filters): void {
            this.filters = filters;
            this.loadPage(1);
        },
        updateSort(sort): void {
            this.sort = sort;
            this.loadPage(1);
        },
        getExportParams() {
            return _.assign({ sort: this.sort }, this.filters);
        },
        editBulletin(bulletin) {
            this.bulletinDeSalaireModal.isNew = false;
            this.bulletinDeSalaireModal.forceEditing = true;
            this.bulletinDeSalaireModal.bulletinDeSalaireId = bulletin.id;
        },
        downloadPdf(bulletin) {
            this.BulletinDeSalaireApi.downloadPdf(bulletin.id);
        },
        onBulletinDeSalaireModalClose() {
            this.bulletinDeSalaireModal.bulletinDeSalaireId = null;
            this.bulletinDeSalaireModal.forceEditing = false;
            this.bulletinDeSalaireModal.isNew = false;
            this.refreshBulletins(false);
        },
        deleteBulletin(bulletin) {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer ce bulletin de salaire&nbsp;?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.BulletinDeSalaireApi.delete(bulletin.id, raison)
                    .then(function () {
                        self.getBulletins();
                        swal(
                            "Le bulletin de salaire a bien été supprimé !",
                            "",
                            "success"
                        );
                    })
                    .catch(function (error) {
                        let data =
                            (error.response && error.response.data) || {};
                        swal(
                            "Suppression impossible",
                            data.message ||
                                (data.error && data.error.message) ||
                                "",
                            "error"
                        );
                    });
            });
        },
        // UI
        openImportModal() {
            this.showImportModal = true;
        },
        onImportModalClose() {
            this.showImportModal = false;
            this.refreshBulletins();
        },
    },
    watch: {
        itemsPerPage: function () {
            this.loadPage(1);
        },
        filters: {
            deep: true,
            handler: function () {
                this.loadPage(1);
            },
        },
        sort: function () {
            this.loadPage(1);
        },
    },
};
